import React from "react";
import { Anchor, Avatar, Box, Heading, Paragraph, ResponsiveContext } from "grommet";
import { IconSvg } from "../../../IconSvg";
export var CardWithLinkAndStatus = function CardWithLinkAndStatus(_ref) {
  var paragraph = _ref.paragraph,
    subtext = _ref.subtext,
    heading = _ref.heading,
    image = _ref.image,
    link = _ref.link;
  return /*#__PURE__*/ React.createElement(
    "div",
    null,
    /*#__PURE__*/ React.createElement(ResponsiveContext.Consumer, null, function (size) {
      return /*#__PURE__*/ React.createElement(
        Box,
        {
          flex: true,
          direction: "column",
          background: {
            color: "site-colors-1",
          },
          width: {
            max: "330px",
          },
          round: "20px",
          gap: "medium",
        },
        /*#__PURE__*/ React.createElement(
          Box,
          {
            gap: "xlarge",
          },
          /*#__PURE__*/ React.createElement(
            Box,
            {
              flex: true,
              direction: "row-reverse",
              justify: "between",
            },
            /*#__PURE__*/ React.createElement(
              Box,
              {
                pad: "small",
              },
              /*#__PURE__*/ React.createElement(Avatar, {
                src: image,
                size: "43px",
              })
            ),
            /*#__PURE__*/ React.createElement(
              Box,
              {
                flex: true,
                color: "light",
                pad: {
                  top: "medium",
                  left: "medium",
                },
              },
              /*#__PURE__*/ React.createElement(
                Heading,
                {
                  level: 4,
                  size: "small",
                  style: {
                    textTransform: "uppercase",
                  },
                },
                heading
              ),
              /*#__PURE__*/ React.createElement(
                Paragraph,
                {
                  size: "small",
                  style: {
                    fontWeight: "bolder",
                  },
                },
                subtext
              )
            )
          ),
          /*#__PURE__*/ React.createElement(
            Box,
            {
              flex: true,
              color: "light",
              pad: {
                horizontal: "medium",
              },
              gap: "large",
            },
            /*#__PURE__*/ React.createElement(
              Box,
              null,
              /*#__PURE__*/ React.createElement(
                Heading,
                {
                  level: 4,
                  size: "small",
                  style: {
                    textTransform: "uppercase",
                  },
                },
                heading
              ),
              /*#__PURE__*/ React.createElement(
                Paragraph,
                {
                  size: "0.75rem",
                },
                subtext
              )
            ),
            /*#__PURE__*/ React.createElement(
              Box,
              null,
              /*#__PURE__*/ React.createElement(Anchor, {
                label: link,
                href: "#",
                size: "xsmall",
              })
            )
          )
        ),
        /*#__PURE__*/ React.createElement(
          Box,
          {
            background: {
              color: "#C5CCD7",
            },
            round: "0 0 20px 20px",
            color: "light",
            pad: {
              vertical: "medium",
              horizontal: "medium",
            },
            gap: "xxsmall",
          },
          /*#__PURE__*/ React.createElement(
            Paragraph,
            {
              size: "small",
              style: {
                fontWeight: "bolder",
              },
            },
            paragraph
          ),
          /*#__PURE__*/ React.createElement(
            Box,
            {
              flex: true,
              direction: "row",
              gap: "8px",
            },
            /*#__PURE__*/ React.createElement(
              Box,
              {
                alignSelf: "center",
              },
              /*#__PURE__*/ React.createElement(IconSvg, {
                src: "status",
              })
            ),
            /*#__PURE__*/ React.createElement(
              Paragraph,
              {
                size: "0.75rem",
              },
              paragraph
            )
          ),
          /*#__PURE__*/ React.createElement("hr", {
            style: {
              backgroundColor: "#B4BBC7",
              width: "100%",
              borderRadius: "100px",
            },
          }),
          /*#__PURE__*/ React.createElement(Anchor, {
            label: link,
            href: "#",
            size: "xsmall",
            style: {
              fontWeight: "700",
            },
          })
        )
      );
    })
  );
};
